module.exports = __webpack_public_path__ + "static/media/svg-6.81b0bda7.svg";